(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    /* "37x37CM / 15x15IN"  ->  { main: '37×37 cm', sub: '15"×15"' } */
  window.wadParseSize = window.wadParseSize || function (v) {
    const m = String(v).match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\s*\/\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:in|")?/i);
    return m ? { main: m[1] + '×' + m[2] + ' cm', sub: m[3] + '"×' + m[4] + '"' } : null;
  };

  /* Hidden finish values: real variants (own price) that are chosen from the frame step, never shown as a Finish card.
     "Rolled Canvas" is presented as "No Frame" + the Rolled swatch in the Canvas Only step. */
  window.wadHiddenFinish = window.wadHiddenFinish || { 'rolled canvas': 'No Frame' };
  /* "Standard Canvas" / "Standard Acrylic" are shown (and matched) as "Classic Canvas" / "Classic Acrylic",
     so the page reads the same before and after the products are renamed in the admin. */
  window.wadCanon = window.wadCanon || function (v) {
    return String(v == null ? '' : v).replace(/^(\s*)standard (canvas|acrylic)(\s*)$/i, (m, a, t, b) => a + 'Classic ' + t.charAt(0).toUpperCase() + t.slice(1).toLowerCase() + b);
  };
  window.wadShownFinish = window.wadShownFinish || function (v) { return window.wadHiddenFinish[String(v || '').trim().toLowerCase()] || v; };

  /* Afterpay / Square instalment message: the app reads the price once on page load.
     Push the new price to it every time the theme switches variant. */
  if (!window.wadAfterpayHooked) {
    window.wadAfterpayHooked = true;
    const SEL = 'square-placement, afterpay-placement, [data-afterpay-placement]';
    const money = (cents) => (cents / 100).toFixed(2);
    const fix = (cents) => {
      if (!cents) return;
      const amount = money(cents);
      document.querySelectorAll(SEL).forEach((el) => {
        if (el.getAttribute('data-amount') !== amount) el.setAttribute('data-amount', amount);
        if (el.hasAttribute('amount') && el.getAttribute('amount') !== amount) el.setAttribute('amount', amount);
      });
      // apps that print plain text ("or 4 interest-free payments of $135.75"): rewrite the instalment amount
      const per = (Math.floor(cents / 4) / 100).toFixed(2);
      const re = /(payments of\s*)(?:A?\$|AU\$)\s?[\d,]+(?:\.\d{2})?/i;
      const scope = document.querySelector('.hdt-main-product, main') || document.body;
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (/payments of/i.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP)
      });
      let t;
      while ((t = walker.nextNode())) {
        const next = t.nodeValue.replace(re, (m, a) => a + '$' + Number(per).toLocaleString('en-AU', { minimumFractionDigits: 2 }));
        if (next !== t.nodeValue) t.nodeValue = next;
      }
      // amount can sit in its own element right after the text ("payments of <strong>$135.75</strong>")
      scope.querySelectorAll('*').forEach((el) => {
        if (el.children.length || !/^\s*(?:A?\$|AU\$)\s?[\d,]+\.\d{2}\s*$/.test(el.textContent)) return;
        const prev = el.previousSibling && (el.previousSibling.textContent || '');
        if (!/payments of\s*$/i.test(prev)) return;
        const txt = '$' + Number(per).toLocaleString('en-AU', { minimumFractionDigits: 2 });
        if (el.textContent.trim() !== txt) el.textContent = txt;
      });
    };
    let last = 0;
    document.addEventListener('variant:change', (e) => {
      const v = e.detail && e.detail.variant;
      if (!v || !v.price) return;
      last = Number(v.price);
      fix(last);
      // the app may re-render a moment later: apply again
      setTimeout(() => fix(last), 400);
      setTimeout(() => fix(last), 1500);
    }, true);
  }

  if (!customElements.get('wad-frame-colours')) {
    class WadFrameColours extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this._ready) return;
        const dataEl = this.querySelector('[data-fc-data]');
        if (!dataEl) return;
        this._ready = true;

        try { this.data = JSON.parse(dataEl.textContent || '{}') || {}; } catch (err) { console.warn('[WAD] frame colour data is not valid JSON', err); this.data = {}; }
        // "Standard Canvas|Floating Frame" -> "Classic Canvas|Floating Frame"
        const canonKey = (k) => k.split('|').map((x, j) => (j === 0 ? window.wadCanon(x) : x)).join('|');
        this.data = Object.fromEntries(Object.entries(this.data || {}).map(([k, v]) => [canonKey(k), v]));
        const mediaEl = this.querySelector('[data-fc-media]');
        try { this.media = JSON.parse((mediaEl && mediaEl.textContent) || '[]'); } catch (err) { this.media = []; }
        const varEl = this.querySelector('[data-fc-variants]');
        try { this.variantMedia = JSON.parse((varEl && varEl.textContent) || '[]'); } catch (err) { this.variantMedia = []; }
        // swatch images from the block setting: one "Finish|Colour|image URL" per line (overrides the metafield swatch)
        this.swatchMap = {};
        (this.dataset.swatches || '').split(/\r?\n/).forEach((line) => {
          const p = line.split('|').map((x) => x.trim());
          if (p.length >= 3 && p[2]) this.swatchMap[(p[0] + '|' + p[1]).toLowerCase()] = p.slice(2).join('|');
        });
        // "Silver" (older product data) is shown and ordered as "White" (code WHT); alt-text matching keeps the old name
        const ALIAS = { silver: { name: 'White', code: 'WHT' } };
        Object.values(this.data || {}).forEach((list) => (Array.isArray(list) ? list : []).forEach((it) => {
          const a = it && ALIAS[String(it.name || '').toLowerCase()];
          if (a) { it.altName = it.name; it.name = a.name; it.code = a.code; }
        }));
        this.applyMeta();
        this.prop = this.dataset.prop || 'Frame Colour';
        this.formId = this.dataset.form;
        this.swatches = this.querySelector('[data-fc-swatches]');
        this.label = this.querySelector('[data-fc-label]');
        this.wrapper = this.closest('.hdt-product__variant-picker');
        this.picker = this.wrapper ? this.wrapper.querySelector('hdt-variant-picker') : null;
        const initial = this.querySelector('.wad-fc__btn.is-selected');
        this.selected = initial ? initial.dataset.name : '';
        this.currentType = '';   // forces a clean build on the first update
        this.titleEl = this.querySelector('[data-fc-title]');
        this.baseTitle = 'Frame Colour';
        this.edgeTitle = this.dataset.edgeTitle || 'Canvas Only';
        this.curProp = this.prop;
        // Nothing counts as chosen until the shopper actually picks. Landing with
        // a swatch lit up next to an image that does not match it reads as a bug,
        // so this step starts blank and the gallery keeps the product's own first
        // image. The variant is unchanged - only the highlight waits.
        this.touched = false;
        this.querySelectorAll('.wad-fc__btn.is-selected').forEach((b) => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        const wake = () => {
          if (this.touched) return;
          this.touched = true;
          if (this.selected) this.choose(this.selected);
        };
        const zone = this.wrapper || this;
        zone.addEventListener('click', wake, true);
        zone.addEventListener('change', wake, true);

        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.wad-fc__btn');
          if (!btn) return;
          e.preventDefault();
          e.stopPropagation();
          if (this.switchRolled(btn.dataset.name)) return;
          this.choose(btn.dataset.name);
        });

        if (this.picker) {
          let queued = false;
          const refresh = () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(() => { queued = false; this.update(); });
          };
          this.picker.addEventListener('click', refresh);
          this.picker.addEventListener('change', refresh);
          new MutationObserver(refresh).observe(this.picker, { childList: true, characterData: true, subtree: true });
        }
        this.src = '';
        this.badgeInit();
        // The theme shows the variant's own photo (always the first colour) when it FINISHES loading the
        // new variant - on a slow first load that is after our switch. Re-apply the chosen colour then.
        const form = document.getElementById(this.formId);
        if (form) {
          form.addEventListener('variant:change', () => {
            clearTimeout(this._vcT1); clearTimeout(this._vcT2); clearTimeout(this._vcT3);
            const again = () => {
              this.update();
              if (this.touched && !this.hidden && this.selected) this.showMedia(this.currentItem(this.selected));
            };
            this._vcT1 = setTimeout(again, 30);
            this._vcT2 = setTimeout(again, 300);
            this._vcT3 = setTimeout(again, 900);
          });
        }
        this.update();
      }

      // Frame option metaobjects -> { "Type|Finish": [ {name, code, swatch, image, media_id} ] }.
      // Old JSON / text metafield stays as the fallback for photos and swatches it already has.
      applyMeta() {
        const el = this.querySelector('[data-fc-meta]');
        let meta = null;
        try { meta = JSON.parse((el && el.textContent) || 'null'); } catch (err) { console.warn('[WAD] frame metaobject data', err); }
        if (!meta || !Array.isArray(meta.options) || !meta.options.length) return;
        const arr = (v) => (Array.isArray(v) ? v : v ? [v] : []);
        const ORDER = ['stretched canvas', 'rolled canvas', 'black', 'white', 'oak', 'natural'];
        const rank = (n) => { const i = ORDER.indexOf(String(n).toLowerCase()); return i < 0 ? 99 : i; };
        const old = this.data || {};
        const oldItem = (key, name) => {
          const type = key.split('|')[0];
          const lists = [old[key], old[type + '|No Frame'], old[type]];
          for (const l of lists) {
            const hit = Array.isArray(l) && l.find((i) => i && String(i.name).toLowerCase() === String(name).toLowerCase());
            if (hit) return hit;
          }
          return null;
        };
        const photos = (meta.photos || []).filter(Boolean);
        const photoFor = (type, finish, name) => photos.find((p) =>
          arr(p.t).map(window.wadCanon).includes(type) && arr(p.f).includes(finish) && String(p.n).toLowerCase() === String(name).toLowerCase());
        const data = {};
        meta.options.forEach((o) => {
          if (!o || !o.n) return;
          arr(o.t).map(window.wadCanon).forEach((type) => arr(o.f).forEach((finish) => {
            const key = type + '|' + finish;
            const list = (data[key] = data[key] || []);
            if (list.some((i) => i.name === o.n)) return;
            const prev = oldItem(key, o.n) || {};
            const ph = photoFor(type, finish, o.n);
            list.push({
              name: o.n,
              code: o.c || prev.code || '',
              swatch: prev.swatch || '',
              image: ph ? ph.src : prev.image || '',
              media_id: ph ? ph.id : null,
              altName: prev.altName
            });
          }));
        });
        Object.values(data).forEach((l) => l.sort((a, b) => rank(a.name) - rank(b.name)));
        // keep old keys the metaobjects do not cover (e.g. a product-specific extra list)
        Object.keys(old).forEach((k) => { if (k.includes('|') && !data[k]) data[k] = old[k]; });
        this.data = data;
        this.fromMeta = true;
      }

      // option values as the customer sees them (hidden "Rolled Canvas" finish reads as "No Frame")
      vals() {
        return this.values().map((v, j) => (j === 1 ? window.wadShownFinish(v) : j === 0 ? window.wadCanon(v) : v));
      }

      // the hidden Rolled radio (only on products that have Rolled variants)
      finishInput(value) {
        if (!this.picker) return null;
        const fs = this.picker.querySelector('.hdt-product-form__input[data-index="1"]');
        if (!fs) return null;
        return Array.from(fs.querySelectorAll('input[type="radio"]')).find((i) => i.value.toLowerCase() === value.toLowerCase()) || null;
      }

      // Stretched -> "No Frame" variant, Rolled -> hidden "Rolled Canvas" variant (own price + compare-at)
      switchRolled(name) {
        if (!/^(rolled|stretched) canvas$/i.test(name || '')) return false;
        const rolled = this.finishInput('Rolled Canvas');
        if (!rolled) return false;                       // product without Rolled variants: keep the old behaviour
        const target = /^rolled/i.test(name) ? rolled : this.finishInput('No Frame');
        if (!target) return false;
        this.selected = name;
        if (!target.checked) {
          target.disabled = false;
          const lab = target.id && this.picker.querySelector('label[for="' + CSS.escape(target.id) + '"]');
          (lab || target).click();
        }
        this.choose(name);
        return true;
      }

      // Which list to show: "Product" normally, "Product|No Frame" for any No Frame finish
      // "Type|Finish" wins when the metafield has it (lets each finish map to its own photos)
      keyFor(vals) {
        const type = vals[0] || '';
        const noFrame = vals.some((v) => /^no frame/i.test(v));
        const specific = type + '|' + (vals[1] || '');
        if (vals[1] && this.data[specific]) return { noFrame, key: specific };
        return { noFrame, key: noFrame ? type + '|No Frame' : type };
      }

      // ---------- main image follows the chosen frame colour ----------
      stem(url) {
        const f = String(url || '').split('?')[0].split('/').pop() || '';
        return f.replace(/\.(jpe?g|png|webp|gif|avif)$/i, '').toLowerCase();
      }

      // key = "Type | Finish | Colour" (same text the CSV puts at the end of each image's alt text).
      // Uses the metafield's media_alt when present, otherwise builds it from the selected options.
      mediaKey(item) {
        if (!item) return '';
        if (item.media_alt) return String(item.media_alt);
        const v = this.vals();
        return [v[0], v[1], item.altName || item.name].filter(Boolean).join(' | ');
      }

      mediaFor(item) {
        if (!item || !this.media.length) return null;
        const norm = (t) => String(t || '').toLowerCase().replace(/\s*\|\s*/g, '|').replace(/\s+/g, ' ').trim()
          .replace(/(^|\|)standard (canvas|acrylic)(?=\||$)/g, '$1classic $2');
        const key = norm(this.mediaKey(item));
        // Which frame the shopper is actually choosing. A photo whose own alt says it
        // shows a different kind of frame is never the right answer, however it was
        // found. This matters because the Frame photo setting and the colour swatch
        // still point at the old floating-frame thumbnails on every product that had
        // no deep-frame photo when it was set up: following those blindly put a
        // floating frame on screen for every Deep Floating Frame.
        const family = (t) => {
          const s = norm(t);
          if (/\|deep floating frame/.test(s)) return 'deep';
          if (/\|(floating frame|flat frame)/.test(s)) return 'shallow';
          if (/\|no frame/.test(s)) return 'bare';
          return '';
        };
        const wantFamily = family(key);
        // The two shortcuts below point at a photo by id or by file name, and on most
        // products they still point at whatever was in the gallery before the
        // thumbnails arrived. Reject a photo whose alt names a different frame, and
        // hold a photo that names no frame at all in reserve: the alt-text and borrow
        // steps further down know what they are looking at, so they go first. The
        // reserve is still returned at the end, so a gallery with no alt text at all
        // behaves exactly as it did before.
        let loose = null;
        const take = (m) => {
          if (!m) return null;
          const f = family(m.alt);
          if (wantFamily && f !== wantFamily) {
            if (!f && !loose) loose = m;
            return null;
          }
          return m;
        };
        // 0) Frame photo picked in admin -> same media in this product's gallery
        if (item.media_id) {
          const byId = take(this.media.find((x) => String(x.id) === String(item.media_id)));
          if (byId) return byId;
        }
        // 1) the colour's "image" (Frame photo / metafield JSON) -> same file in this product's gallery
        const want = this.stem(item.image || item.product_image);
        if (want) {
          const byFile = take(this.media.find((x) => this.stem(x.src).startsWith(want)));
          if (byFile) return byFile;
        }
        // 2) image alt text ending in "Type | Finish | Colour"
        if (!key) return null;
        const hit = this.media.find((x) => norm(x.alt).endsWith(key));
        if (hit) return hit;
        // 2b) The acrylic "No Frame" finishes have no Frame Colour step, so their
        //     alt text is only "Type | Finish". mediaKey still appends whatever was
        //     selected last (e.g. "Stretched Canvas"), giving a 3-part key that
        //     matches nothing. Try again without that trailing segment.
        const parts = key.split('|');
        const shortKey = parts.length > 2 ? parts.slice(0, 2).join('|') : '';
        if (shortKey) {
          const hitShort = this.media.find((x) => norm(x.alt).endsWith(shortKey));
          if (hitShort) return hitShort;
        }
        // 3) No photo carries that exact alt. Borrow one that shows the SAME FRAME,
        //    because the frame is what the shopper is choosing. Frames fall into two
        //    families and a photo must never cross between them - a deep floating frame
        //    is a different object from a floating / flat frame:
        //      deep    : canvas "Deep Floating Frame"  ==  acrylic "Deep Floating Frame With/No Border"
        //      shallow : canvas "Floating Frame"       ==  acrylic "Flat Frame With/No Border"
        //    Inside one family the frame looks the same whatever it is wrapped around, and
        //    Premium and Classic are the same artwork, so any member can stand in. Ranked
        //    best first: same material, then the matching border, then the other tier.
        //    Unframed is its own case - bare canvas and bare acrylic look nothing alike,
        //    so those only ever swap Premium <-> Classic.
        const borrow = (k) => {
          const bits = /^(premium|classic) (canvas|acrylic)\|(.+)$/.exec(k);
          if (!bits) return [];
          const tier = bits[1], material = bits[2], rest = bits[3];
          const other = tier === 'premium' ? 'classic' : 'premium';
          const deep = /^deep floating frame/.test(rest);
          const shallow = /^(floating frame|flat frame)/.test(rest);
          if (!deep && !shallow) return [other + ' ' + material + '|' + rest];
          const colour = (rest.split('|')[1] || '').trim();
          if (!colour) return [];
          const borders = /with border/.test(rest)
            ? ['with border', 'no border']
            : ['no border', 'with border'];
          const acrylic = borders.map(
            (b) => 'acrylic|' + (deep ? 'deep floating frame ' : 'flat frame ') + b
          );
          const canvas = ['canvas|' + (deep ? 'deep floating frame' : 'floating frame')];
          const groups = material === 'canvas' ? canvas.concat(acrylic) : acrylic.concat(canvas);
          const out = [];
          groups.forEach((g) => {
            [tier, other].forEach((t) => {
              const cand = t + ' ' + g + '|' + colour;
              if (cand !== k && out.indexOf(cand) < 0) out.push(cand);
            });
          });
          return out;
        };
        const tryKeys = shortKey ? [key, shortKey] : [key];
        for (let c = 0; c < tryKeys.length; c++) {
          const candidates = borrow(tryKeys[c]);
          for (let i = 0; i < candidates.length; i++) {
            const hitSwap = this.media.find((x) => norm(x.alt).endsWith(candidates[i]));
            if (hitSwap) return hitSwap;
          }
        }
        return loose;
      }

      showMedia(item) {
        const dbg = (...a) => { if (window.WAD_DEBUG) console.info('[WAD frame image]', ...a); };
        let m = item ? this.mediaFor(item) : null;
        if (!m) m = this.selectedVariantMedia();
        // On a variant change the theme calls this with no item, and plenty of
        // products have no usable variant image of their own. That used to dead-end
        // here and leave the gallery on whatever happened to be showing. Fall back
        // to the photo for the Type / Finish / Colour that is actually selected.
        if (!m) {
          const current = this.currentItem(this.selected);
          if (current) m = this.mediaFor(current);
        }
        const realPhoto = item && item.image && item.image !== item.swatch ? item.image : '';
        if (!m) {
          if (this.swapMain(realPhoto)) { dbg('not in gallery, main image swapped to JSON image', realPhoto); return; }
          dbg('no image for', item ? item.name : '(variant)', '- alt texts:', this.media.map((x) => x.alt));
          return;
        }
        // the gallery block of THIS section: <hdt-product-media section-id="..."> holding
        // <hdt-slider> (main) and <hdt-slider-thumb> (thumbnails)
        const root = document.querySelector('hdt-product-media[section-id="' + this.dataset.sectionId + '"]') ||
          (this.grid && this.grid.querySelector('hdt-product-media'));
        if (!root) { dbg('gallery <hdt-product-media> not found'); return; }
        const main = root.querySelector('hdt-slider');
        const thumbs = root.querySelector('hdt-slider-thumb');
        const want = this.stem(m.src);
        const srcOf = (img) => ((img.currentSrc || img.getAttribute('src') || img.dataset.src || '') + ' ' + (img.getAttribute('srcset') || img.dataset.srcset || '')).toLowerCase();
        const isMatch = (slide) =>
          slide.matches('[data-media-id="' + m.id + '"]') ||
          !!slide.querySelector('[data-media-id="' + m.id + '"]') ||
          Array.from(slide.querySelectorAll('img')).some((img) => srcOf(img).includes(want));
        const slidesOf = (el) => (el ? Array.from(el.querySelectorAll('.hdt-slider__slide:not([hidden])')) : []);

        // Drive the MAIN slider, and never click a thumbnail. In this theme a gallery
        // thumbnail is bound to its own variant, so clicking one re-selects that
        // variant. When a type has no photo of its own and borrows another's -
        // Premium Canvas showing the Classic floating-frame shot - that click
        // dragged the whole selection onto the wrong variant.
        const ms = slidesOf(main);
        const idx = ms.findIndex(isMatch);
        if (idx < 0) {
          if (this.swapMain(realPhoto)) { dbg('slide not found, main image swapped to JSON image', realPhoto); return; }
          dbg('image not found in gallery', want); return;
        }
        // keep the thumbnail strip's highlight in step, by class only
        const t = slidesOf(thumbs).find(isMatch);
        if (t) {
          slidesOf(thumbs).forEach((s) => s.classList.remove('is-selected', 'is-thumb-selected'));
          t.classList.add('is-selected', 'is-thumb-selected');
        }
        const api = main && (main.embla || main.emblaApi || main.slider || main.instance);
        if (api && typeof api.scrollTo === 'function') { dbg('slider api scrollTo', idx); api.scrollTo(idx); return; }
        if (main && typeof main.select === 'function') { dbg('slider select', idx); main.select(idx); return; }
        dbg('scrollIntoView', idx);
        ms[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      // featured image of the variant matching the current Type / Finish / Size
      selectedVariantMedia() {
        const vals = this.values();
        const v = (this.variantMedia || []).find((x) => x.o.every((o, j) => o === vals[j]));
        if (!v || !v.m) return null;
        return this.media.find((x) => String(x.id) === String(v.m)) || null;
      }

      // last resort: put the JSON image straight into the main image currently on show
      swapMain(url) {
        if (!url || !this.grid) return false;
        const best = this.mainImage();
        if (!best) return false;
        const img = best.img;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
        return true;
      }

      // re-apply after the theme has swapped in the variant image (it does that after our click handler)
      queueMedia(item) {
        const sig = this.values().join('|') + '|' + (item ? item.name : '');
        if (sig === this._mediaSig) return;
        const first = this._mediaSig === undefined;
        this._mediaSig = sig;
        if (first) return; // page load: the theme already shows the selected variant's image
        clearTimeout(this._mediaT1); clearTimeout(this._mediaT2);
        this._mediaT1 = setTimeout(() => this.showMedia(item), 60);
        this._mediaT2 = setTimeout(() => this.showMedia(item), 450);
      }

      // Selected value of each option (checked radio first, theme label as fallback)
      values() {
        if (!this.picker) return [];
        return Array.from(this.picker.querySelectorAll('.hdt-product-form__input[data-index]')).map((fs) => {
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) return checked.value;
          const el = fs.querySelector('[update-value]');
          return el ? el.textContent.trim() : '';
        });
      }

      // ---------- frame image badge on the product media ----------
      badgeInit() {
        this.grid = document.querySelector('.hdt-secion-main-product--' + this.dataset.sectionId);
        if (!this.grid) return;
        this.badge = document.createElement('img');
        this.badge.className = 'wad-media-badge';
        this.badge.alt = '';
        this.badge.setAttribute('aria-hidden', 'true');
        this.badge.hidden = true;
        let t;
        const later = () => { clearTimeout(t); t = setTimeout(() => this.badgePlace(), 120); };
        window.addEventListener('resize', later);
        ['scroll', 'load', 'click', 'transitionend'].forEach((ev) => this.grid.addEventListener(ev, later, true));
        this.badgeObsOpts = { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] };
        this.badgeObs = new MutationObserver(later);
        this.badgeObs.observe(this.grid, this.badgeObsOpts);
      }

      // visible rectangle of an element after clipping by overflow:hidden/auto ancestors
      visibleRect(el) {
        const r = el.getBoundingClientRect();
        let L = r.left, T = r.top, R = r.right, B = r.bottom;
        for (let p = el.parentElement; p && p !== this.grid.parentElement; p = p.parentElement) {
          const cs = getComputedStyle(p);
          if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
            const pr = p.getBoundingClientRect();
            L = Math.max(L, pr.left); T = Math.max(T, pr.top); R = Math.min(R, pr.right); B = Math.min(B, pr.bottom);
          }
        }
        return R > L && B > T ? { L, T, R, B } : null;
      }

      // the element the badge is positioned against: top-most real box above the image, below the grid
      mediaCol(img) {
        const path = [];
        for (let p = img.parentElement; p && p !== this.grid; p = p.parentElement) path.push(p);
        for (let i = path.length - 1; i >= 0; i--) {
          const el = path[i];
          if (getComputedStyle(el).display !== 'contents' && el.getBoundingClientRect().width > 0) return el;
        }
        return null;
      }

      // the main image currently on show (largest visible, non-thumbnail image of the gallery)
      mainImage() {
        let best = null;
        this.grid.querySelectorAll('img').forEach((img) => {
          if (img === this.badge || img.closest('.hdt-product-info__item') || img.closest('hdt-sticky-btn-atc')) return;
          const r = this.visibleRect(img);
          if (!r) return;
          const w = r.R - r.L, h = r.B - r.T;
          if (w < 200 || h < 150) return;
          const a = w * h;
          if (!best || a > best.a * 1.05) best = { img, rect: r, a };
        });
        if (!best) return null;
        best.col = this.mediaCol(best.img);
        return best.col ? best : null;
      }

      badgePlace() {
        if (!this.badge) return;
        this.badgeObs.disconnect();
        try {
          const m = this.src ? this.mainImage() : null;
          if (!m) { this.badge.hidden = true; return; }
          const col = m.col;
          if (this.badge.parentElement !== col) col.appendChild(this.badge);
          if (this.badge.getAttribute('src') !== this.src) this.badge.src = this.src;
          if (getComputedStyle(col).position === 'static') col.style.position = 'relative';
          this.badge.hidden = false;
          const cr = col.getBoundingClientRect();
          const s = this.badge.offsetWidth || 56;
          this.badge.style.left = (m.rect.R - cr.left - col.clientLeft - s - 10) + 'px';
          this.badge.style.top = (m.rect.B - cr.top - col.clientTop - s - 10) + 'px';
        } finally {
          this.badgeObs.observe(this.grid, this.badgeObsOpts);
        }
      }

      // Step numbers: Type 1, Finish 2, Frame Colour 3, Size 4 (Size is 3 when there is no frame step)
      renumber() {
        if (!this.wrapper) return;
        if (!this._gapDone && this.picker) {
          this._gapDone = true;
          const g = getComputedStyle(this.picker).rowGap;
          if (g && g !== 'normal' && parseFloat(g) > 0) this.wrapper.style.setProperty('--wad-step-gap', g);
        }
        const shown = !this.hidden;
        this.wrapper.querySelectorAll('hdt-variant-picker [data-wad-step]').forEach((el) => {
          const n = Number(el.dataset.wadStep);
          const t = String(n > 2 && shown ? n + 1 : n);
          if (el.textContent !== t) el.textContent = t;
        });
      }

      update() {
        this.update2();
        this.renumber();
      }

      update2() {
        const { noFrame, key } = this.keyFor(this.vals());
        // No list for this combination (e.g. acrylic + No Frame) = nothing to choose, hide the step
        const list = this.data[key] || [];

        if (!list.length) {
          this.hidden = true;
          this.sync(null);
          this.src = '';
          this.badgePlace();
          this.queueMedia(null);
          document.dispatchEvent(new CustomEvent('wad:frame-colour:change', { detail: { name: '', code: '' } }));
          return;
        }
        this.hidden = false;

        const finishNow = this.values()[1] || '';
        // Stretched / Rolled follows the real variant when the product has Rolled variants
        if (this.finishInput('Rolled Canvas') && list.some((i) => /^rolled canvas$/i.test(i.name))) {
          const isRolled = /^rolled canvas$/i.test(finishNow);
          const want = list.find((i) => (isRolled ? /^rolled canvas$/i : /^stretched canvas$/i).test(i.name));
          if (want) this.selected = want.name;
        }
        if (this.currentType !== key || this._finish !== finishNow) {
          this.currentType = key;
          this._finish = finishNow;
          // heading + line item property name follow the list (Frame Colour / Canvas Only)
          const title = noFrame ? this.edgeTitle : this.baseTitle;
          if (this.titleEl && this.titleEl.textContent !== title) this.titleEl.textContent = title;
          this.curProp = noFrame ? this.edgeTitle : this.prop;
          if (!list.some((i) => i.name === this.selected)) this.selected = list[0].name;
          this.build(list);
        }
        this.choose(this.selected || list[0].name);
      }

      swatchFor(item) {
        const finish = this.vals()[1] || '';
        return this.swatchMap[(finish + '|' + item.name).toLowerCase()] || String(item.swatch || '');
      }

      build(list) {
        this.swatches.textContent = '';
        list.forEach((item) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'wad-fc__btn';
          btn.dataset.name = item.name;
          btn.dataset.code = item.code || '';
          btn.title = item.name;
          const sw = this.swatchFor(item);
          if (/^(https?:)?\/\//.test(sw) || sw.startsWith('/')) {
            const img = document.createElement('img');
            img.src = sw; img.alt = item.name; img.width = 60; img.height = 60; img.loading = 'lazy';
            btn.appendChild(img);
          } else {
            const dot = document.createElement('span');
            dot.className = 'wad-fc__dot';
            dot.style.background = sw;
            btn.appendChild(dot);
          }
          this.swatches.appendChild(btn);
        });
      }

      currentItem(name) {
        const list = this.data[this.currentType] || [];
        return list.find((i) => i.name === name) || list[0] || null;
      }

      choose(name) {
        const item = this.currentItem(name);
        if (!item) return;
        this.selected = item.name;
        // The default variant is "Canvas Only: Stretched Canvas", so ordinary
        // highlighting on load marks that one value and nothing else. The gallery is
        // the part that must not move: it stays on the image the page landed with
        // until the shopper actually picks something (this.touched).
        this.swatches.querySelectorAll('.wad-fc__btn').forEach((b) => {
          const on = b.dataset.name === item.name;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on);
        });
        if (this.label && this.label.textContent !== item.name) this.label.textContent = item.name;
        this.sync(item);
        const sw = this.swatchFor(item);
        this.src = /^(https?:)?\/\//.test(sw) || sw.startsWith('/') ? sw : '';
        this.badgePlace();
        if (this.touched) this.queueMedia(item);
        document.dispatchEvent(new CustomEvent('wad:frame-colour:change', { detail: { name: item.name, code: item.code } }));
      }

      // Put the choice on the product form and the sticky add-to-cart form as line item properties
      sync(item) {
        const sel = 'form[id="' + this.formId + '"], form[id^="form-product-sticky"]';
        const props = [
          ['data-wad-frame', 'properties[' + (this.curProp || this.prop) + ']', item ? item.name : ''],
          ['data-wad-frame-code', 'properties[_Frame Code]', item ? item.code || '' : '']
        ];
        document.querySelectorAll(sel).forEach((form) => {
          props.forEach(([attr, name, value]) => {
            let input = form.querySelector('input[' + attr + ']');
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.setAttribute(attr, '');
              input.name = name;
              form.appendChild(input);
            }
            input.name = name;
            input.value = value;
            input.disabled = !item || !value;
          });
        });
      }
    }
    customElements.define('wad-frame-colours', WadFrameColours);
  }

  if (!customElements.get('wad-variant-availability')) {
    class WadVariantAvailability extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this._ready) return;
        const dataEl = this.querySelector('[data-wad-variants]');
        if (!dataEl) return;
        this.variants = JSON.parse(dataEl.textContent || '[]');
        this.note = this.dataset.note || '';
        this.hideFor = (this.dataset.hideFor || '').split(',').map((n) => n.trim().toLowerCase()).filter(Boolean);
        this.solid = (this.dataset.solid || '').split(',').map((n) => n.trim().toLowerCase()).filter(Boolean);
        // subtitles: one "Option value|Subtitle" per line
        this.subs = {};
        (this.dataset.subtitles || '').split(/\r?\n|;/).forEach((line) => {
          const i = line.indexOf('|');
          if (i > 0) this.subs[window.wadCanon(line.slice(0, i).trim()).toLowerCase()] = line.slice(i + 1).trim();
        });
        // every Type the store sells, in display order; ones this product lacks are shown greyed out
        this.allTypes = (this.dataset.allTypes || '').split(',').map((t) => window.wadCanon(t.trim())).filter(Boolean);
        const wrapper = this.closest('.hdt-product__variant-picker');
        this.wrapper = wrapper;
        this.picker = wrapper ? wrapper.querySelector('hdt-variant-picker') : null;
        if (!this.picker) return;
        this._ready = true;

        // Block any click on an unavailable value before the theme sees it
        const block = (e) => {
          if (e.target.closest && e.target.closest('[data-wad-unavailable]')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        };
        this.picker.addEventListener('click', block, true);
        this.picker.addEventListener('keydown', (e) => {
          if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-wad-unavailable]')) block(e);
        }, true);

        this.observer = new MutationObserver(() => this.schedule());
        this.watch();
        this.picker.addEventListener('change', () => this.schedule());
        document.addEventListener('wad:frame-colour:change', () => this.summary());
        this.apply();
      }

      watch() {
        this.observer.observe(this.picker, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }

      schedule() {
        if (this._queued) return;
        this._queued = true;
        requestAnimationFrame(() => { this._queued = false; this.apply(); });
      }

      fieldsets() {
        return Array.from(this.picker.querySelectorAll('.hdt-product-form__input[data-index]'));
      }

      // checked radio first (always the real option value), theme label as fallback
      selectedValues() {
        return this.fieldsets().map((fs) => {
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) return checked.value;
          const label = fs.querySelector('[update-value]');
          return label ? label.textContent.trim() : '';
        });
      }

      items(fs) {
        const out = [];
        const inputs = fs.querySelectorAll('input[type="radio"]');
        if (inputs.length) {
          inputs.forEach((input) => {
            let el = null;
            if (input.id) el = fs.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (!el) el = input.closest('label') || input.nextElementSibling;
            out.push({ el: el || input, input, value: input.value });
          });
          return out;
        }
        fs.querySelectorAll('[data-value], [role="option"]').forEach((el) => {
          out.push({ el, input: null, value: el.dataset.value || el.getAttribute('value') || el.textContent.trim() });
        });
        return out;
      }

      // direct child of the .wad-grid container that holds this value
      gridItem(el) {
        const grid = el.closest('.wad-grid');
        if (!grid) return null;
        let n = el;
        while (n && n.parentElement !== grid) n = n.parentElement;
        return n || null;
      }

      textNode(el, value) {
        const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        const want = String(value).trim().toLowerCase();
        let t;
        while ((t = w.nextNode())) if (t.nodeValue.trim().toLowerCase() === want) return t;
        return null;
      }

      // Heading value (right side, green). Own span so the theme can keep its [update-value] untouched.
      header(fs, raw) {
        const lg = fs.querySelector('legend');
        if (!lg) return;
        let f = lg.querySelector('.wad-step-fmt');
        if (!f) {
          f = document.createElement('span');
          f.className = 'wad-step-value wad-step-fmt';
          lg.appendChild(f);
          lg.classList.add('wad-has-fmt');
        }
        const sz = window.wadParseSize(raw);
        const text = sz ? sz.main + ' (' + sz.sub + ')' : raw;
        if (f.textContent !== text) f.textContent = text;
      }

      // Card look: subtitle, size formatting, selected state
      decorate(el, input, value, isSelected) {
        if (!input) return;
        const card = el.closest('.hdt-swatch__item, .hdt-selector__item') || el;
        card.classList.add('wad-card');
        // button text: "Standard Canvas" -> "Classic Canvas" (the option value itself is unchanged)
        const label = window.wadCanon(value);
        if (label !== value) {
          const tn = this.textNode(el, value);
          if (tn) tn.nodeValue = tn.nodeValue.replace(String(value).trim(), label);
        }
        card.classList.toggle('wad-on', isSelected);
        el.classList.add('wad-pad');
        if (card.parentElement) card.parentElement.classList.add('wad-grid');
        if (el.querySelector('.wad-sub')) return;

        const sz = window.wadParseSize(value);
        // "Flat Frame With Border" -> "Flat Frame" + small "With Border" (button text only; the value is unchanged)
        const border = String(value).trim().match(/^(.+?)\s+(with border|no border)$/i);
        let sub = '';
        if (sz) {
          const t = this.textNode(el, value);
          if (!t) return;
          t.nodeValue = sz.main;
          sub = sz.sub;
        } else if (border && !this.subs[window.wadCanon(String(value).trim()).toLowerCase()]) {
          const t = this.textNode(el, value);
          if (!t) return;
          t.nodeValue = border[1];
          sub = border[2].replace(/\b\w/g, (ch) => ch.toUpperCase());
        } else {
          sub = this.subs[window.wadCanon(String(value).trim()).toLowerCase()] || '';
        }
        if (sub) {
          const s = document.createElement('small');
          s.className = 'wad-sub';
          s.textContent = sub;
          el.appendChild(s);
        }
      }

      // Product · Finish · Size · Colour
      summary() {
        const box = this.wrapper && this.wrapper.querySelector('[data-wad-summary]');
        if (!box || !this._sel) return;
        const parts = (this._shown || this._sel)
          .map((v, j) => {
            if (!this._usable[j]) return '';
            const sz = window.wadParseSize(v);
            return sz ? sz.main : v;
          })
          .filter(Boolean);
        const fc = this.wrapper.querySelector('wad-frame-colours');
        const lab = fc && !fc.hidden && fc.querySelector('[data-fc-label]');
        if (lab && lab.textContent.trim()) parts.push(lab.textContent.trim());
        const text = parts.join(' · ');
        if (box.textContent !== text) box.textContent = text;
        box.hidden = !parts.length;
      }

      apply() {
        if (!this.variants || !this.variants.length) return;
        const sel = this.selectedValues();
        // Ignore selections that are not real option values (e.g. "Choose an option")
        const known = sel.map((_, j) => new Set(this.variants.map((v) => v.o[j])));
        const usable = sel.map((v, j) => known[j].has(v));
        this._sel = sel;
        this._usable = usable;
        const shown = sel.map((v, j) => (j === 1 ? window.wadShownFinish(v) : v));
        this._shown = shown.map((v, j) => (j === 0 ? window.wadCanon(v) : v));

        this.observer.disconnect();
        this.fieldsets().forEach((fs, i) => {
          const optName = (fs.dataset.optionName || '').trim().toLowerCase();
          const hideFully = this.hideFor.includes(optName);
          if (this.solid.includes(optName)) fs.setAttribute('data-wad-solid', '');
          this.header(fs, i === 0 ? window.wadCanon(shown[i] || '') : shown[i] || '');

          this.items(fs).forEach(({ el, input, value }) => {
            const gi = this.gridItem(el);
            // hidden finish (Rolled): never shown, never marked unavailable, always clickable from the frame step
            if (i === 1 && window.wadHiddenFinish[String(value).trim().toLowerCase()]) {
              const wrap0 = el.closest('.hdt-swatch__item, .hdt-selector__item');
              [el, wrap0, gi].forEach((n) => { if (n) { n.hidden = true; n.style.display = 'none'; n.setAttribute('data-wad-hidden', ''); } });
              el.removeAttribute('data-wad-unavailable');
              if (input) { input.disabled = false; delete input.dataset.wadDisabled; }
              return;
            }
            // The theme hides values carrying "is-unavailable"; remove it so every value stays visible
            [el, input, el.parentElement, el.closest('.hdt-swatch__item, .hdt-selector__item'), gi].forEach((node) => {
              if (!node) return;
              node.removeAttribute && node.removeAttribute('data-wad-hidden');
              if (node.classList) node.classList.remove('is-unavailable');
              node.hidden = false;
              if (node.style && node.style.display === 'none') node.style.removeProperty('display');
            });
            const isSelected = value === shown[i];
            const ok =
              isSelected ||
              this.variants.some(
                (v) => v.a && v.o[i] === value && sel.every((s, j) => j >= i || !usable[j] || v.o[j] === s)
              );
            this.toggle(el, input, !ok);
            this.decorate(el, input, value, isSelected);

            // Chosen options (default: Finish) remove unavailable values completely instead of fading them
            if (hideFully && !ok) {
              const wrap = el.closest('.hdt-swatch__item, .hdt-selector__item');
              [el, wrap, gi].forEach((n) => {
                if (!n) return;
                n.hidden = true;
                n.style.display = 'none';
                n.setAttribute('data-wad-hidden', '');
              });
            }
          });
        });
        this.placeholders();
        this.summary();
        this.watch();
        this.fix(sel, usable);
      }

      // The selection is not a real variant (e.g. Type switched to Canvas while an acrylic-only Finish
      // was selected). Move the later options to the closest real variant, one option per pass:
      // keep Type, then keep Finish if possible, then keep Size if possible, prefer available variants.
      fix(sel, usable) {
        if (!usable.every(Boolean) || sel.length < 2) return;
        if (this.variants.some((v) => v.o.every((x, j) => x === sel[j]))) { this._fixes = 0; return; }
        if ((this._fixes = (this._fixes || 0) + 1) > 6) return; // safety: never loop
        // framed stays framed, unframed stays unframed (Flat Frame -> Floating Frame, No Frame With Border -> No Frame)
        const framed = (x) => !/^(no frame|rolled)/i.test(String(x || ''));
        const score = (v) =>
          v.o.reduce((t, x, j) => t + (x === sel[j] ? Math.pow(10, v.o.length - j) : 0), 0) +
          (framed(v.o[1]) === framed(sel[1]) ? 50 : 0) + (v.a ? 1 : 0);
        const best = this.variants
          .filter((v) => v.o[0] === sel[0])
          .sort((a, b) => score(b) - score(a))[0];
        if (!best) return;
        const j = best.o.findIndex((x, k) => x !== sel[k]);
        if (j < 0) return;
        const fs = this.fieldsets()[j];
        if (!fs) return;
        const hit = this.items(fs).find((it) => it.value === best.o[j]);
        if (!hit) return;
        if (hit.input) { hit.input.disabled = false; delete hit.input.dataset.wadDisabled; }
        hit.el.removeAttribute('data-wad-unavailable');
        (hit.el || hit.input).click();
      }

      // Show every Type from the block setting; the ones this product does not have become greyed-out,
      // non-clickable cards (same look as unavailable sizes). They have no input, so nothing can select them.
      placeholders() {
        const fs = this.fieldsets()[0];
        if (!fs) return;
        fs.querySelectorAll('[data-wad-placeholder]').forEach((n) => n.remove());
        if (!this.allTypes.length) return;
        const its = this.items(fs).filter((it) => it.input);
        if (!its.length) return;
        const grid = its[0].el.closest('.wad-grid');
        if (!grid) return;
        const have = new Set(its.map((it) => window.wadCanon(it.value)));
        const units = {};
        its.forEach((it) => {
          const g = this.gridItem(it.el);
          const ig = this.gridItem(it.input);
          units[window.wadCanon(it.value)] = [ig && ig !== g ? ig : null, g].filter(Boolean);
        });
        const tpl = its.find((it) => !it.input.checked) || its[0];
        const tplUnit = this.gridItem(tpl.el);
        if (!tplUnit) return;
        this.allTypes.forEach((type) => {
          if (have.has(type)) return;
          const c = tplUnit.cloneNode(true);
          c.querySelectorAll('input').forEach((n) => n.remove());
          [c, ...c.querySelectorAll('*')].forEach((n) => {
            ['id', 'for', 'data-value-id', 'form', 'name'].forEach((a) => n.removeAttribute(a));
            n.classList.remove('wad-on', 'is-selected', 'active', 'is-active', 'is-checked');
          });
          c.querySelectorAll('.wad-unavailable-note').forEach((n) => n.remove());
          const lab = c.matches('label') ? c : c.querySelector('label') || c;
          const t = this.textNode(lab, window.wadCanon(tpl.value)) || this.textNode(lab, tpl.value);
          if (t) t.nodeValue = type;
          const subText = this.subs[type.toLowerCase()] || '';
          let sub = lab.querySelector('.wad-sub');
          if (sub) { sub.textContent = subText; sub.hidden = !subText; }
          else if (subText) { sub = document.createElement('small'); sub.className = 'wad-sub'; sub.textContent = subText; lab.appendChild(sub); }
          if (this.note) {
            const n = document.createElement('span');
            n.className = 'wad-unavailable-note';
            n.textContent = this.note;
            lab.appendChild(n);
          }
          [c, lab].forEach((n) => {
            n.classList.add('wad-unavailable', 'wad-placeholder');
            n.setAttribute('data-wad-unavailable', 'true');
            n.setAttribute('aria-disabled', 'true');
          });
          c.setAttribute('data-wad-placeholder', '');
          c.hidden = false;
          c.style.removeProperty('display');
          units[type] = [c];
        });
        // put the cards in the configured order (only move nodes when the order is actually different)
        const order = this.allTypes.concat([...have].filter((v) => !this.allTypes.includes(v)));
        const want = order.flatMap((v) => units[v] || []);
        const cur = Array.from(grid.children).filter((n) => want.includes(n));
        if (cur.some((n, k) => n !== want[k]) || cur.length !== want.length) want.forEach((n) => grid.appendChild(n));
      }

      toggle(el, input, off) {
        const wrap = el.closest('.hdt-swatch__item, .hdt-selector__item');
        [el, input, wrap].forEach((n) => n && n.classList.toggle('wad-unavailable', off));
        if (off) el.setAttribute('data-wad-unavailable', 'true');
        else el.removeAttribute('data-wad-unavailable');
        el.setAttribute('aria-disabled', off ? 'true' : 'false');

        if (input) {
          if (off) {
            input.disabled = true;
            input.dataset.wadDisabled = '1';
          } else if (input.dataset.wadDisabled) {
            input.disabled = false;
            delete input.dataset.wadDisabled;
          }
        }

        if (el !== input && this.note) {
          let n = el.querySelector(':scope > .wad-unavailable-note');
          if (off && !n) {
            n = document.createElement('span');
            n.className = 'wad-unavailable-note';
            n.textContent = this.note;
            el.appendChild(n);
          } else if (!off && n) {
            n.remove();
          }
        }
      }
    }
    customElements.define('wad-variant-availability', WadVariantAvailability);
  }
  } catch(e) { console.error(e); }
})();

})();
